<template>
  <div class="login">
      <div class="login-left">
        <div class="hongen-logo">
          <img src="../../assets/images/hongen-logo.png" alt="">
        </div>
        <div v-if="ifAllLogo" class="all-logo">
          <img src="../../assets/images/all-logo.png" alt="">
        </div>
      </div>
      <div class="login-right">
          <!-- <p @click="openGg" class="til"><a-icon type="sound" /> 蜘蛛网（现更名为“E企测”）改版公告</p> -->
          <div class="logo">
            <img src="../../assets/images/account/logo.png" alt="">
          </div>
           <a-tabs defaultActiveKey="2" :tabBarStyle="{ border: 0 }">
            <a-tab-pane tab="密码登录" key="2" forceRender><Form type="pwd" /></a-tab-pane>
            <a-tab-pane tab="验证码登录" key="1"><Form type="phone" /></a-tab-pane>
          </a-tabs>
      </div>
      <a-modal v-model="visible" title='改版公告' :footer="null" :closable="false">
        <div style="font-size:20px;">
          <p style="line-height: 35px;">
              升级通知：      尊敬的企业客户，为感谢您长期以来对我司的支持，近期平台将进行改版升级，以确保后续为您提供更优质的服务。原"企业质控信息化”平台名称变更为“e企测”平台；并对页面布局进行了优化，原有功能未做变更。若您在浏览网站和使用产品过程中有任何建议或疑问，请联系19906876274。
          </p>
        </div>
        <div style="text-align: center;margin-top: 20px">
          <a-icon style="font-size: 26px;cursor: pointer;font-weight: 700" type="close" @click="closeGg" />
        </div>
      </a-modal>
  </div>
</template>

<script>
import Form from '@/components/account/login/Form.vue'

export default {
  props: [ 'device' ],
  components: { Form },
  data() {
    return {
      visible: false,
      ifAllLogo: false,
    };
  },
  created() {
      let params = this.$route.query;
      if(params.all) {
        this.ifAllLogo = true;
      }
  },

  methods: {
    goHome() {
      window.location.href = "https://www.hongenwangluo.com/";
    },
    openGg() {
      this.visible = true;
    },
    closeGg() {
      this.visible = false;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ant-modal-header {
  text-align: center;
  background-color: #FFA100;
  padding: 10px 24px;
  .ant-modal-title {
    color: #fff;
    font-size: 22px;
    font-weight: 700;
  }
}
.login {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    .login-left {
      width: 60%;
      height: 100%;
      background: url('../../assets/images/login-bg.png') center no-repeat;
      background-size: 100% 100%;
      .hongen-logo {
        position: relative;
        img {
          position: absolute;
          top: 23px;
          left: 3%;
          width: 12%;
        }
      }
      .all-logo {
      position: relative;
        img {
          position: absolute;
          top: 26px;
          left: 18%;
          width: 34%;
        }
      }
    }
    .login-right {
      width: 40%;
      height: 100%;
      padding: 150px 100px;
      box-sizing: border-box;
      .til {
        font-size: 20px;
        width: 75%;
        height: 50px;
        line-height: 40px;
        text-align: center;
        background-color: #FFA100;
        color: #fff;
        margin: 0 auto 50px;
        padding: 5px 15px;
        cursor: pointer;
      }
      .logo {
        width: 157px;
        height: 111px;
        margin: 20px auto;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .ant-tabs {
          background: #fff;
          padding: 15px 30px;
          width: 100%;
          border-radius: 0 8px 8px 0; 
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 8px;
          float: left;
          /deep/.ant-tabs-nav {
            width: 100% !important;
            > div {
              display: flex;
              justify-content: space-around;
            }
            .ant-tabs-tab {width: 30%;text-align:center;margin:0 10%;}
            .ant-tabs-content {
              padding: 0 40px;
            }
          }
        }
    }

}
@media only screen and (max-width: 900px){
  .login {
    .login-left {
      display: none;
    }
    .login-right {
      width: 100%;
      padding: 30px 0;
    }
  }
}
</style>
